import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { CodetableListState } from './types-store';

export const compareStateWithRequestedProps =
  (state: CodetableListState, codetableId: number, categoryId: number, model: FilterSearchModel) =>
    (state ? codetableId === state.fetchingCodetableId : codetableId === undefined) &&
    (state && state.category ? categoryId === state.category.value : categoryId === undefined) &&
    (state && state.requestedSearchModel ? state.requestedSearchModel === model : model === undefined);
